@if (!control().untouched && control().invalid) {
  <div class="form-error" role="alert">
    @for (error of getErrors(); track error) {
      <span>{{ getErrorMessage(error) }}</span>
    }
  </div>
}
